// extracted by mini-css-extract-plugin
module.exports = {"editVaultFileWindow":"editVaultFileWindow__I-1TK","commentsMode":"commentsMode__svaVq","folderPathGroup":"folderPathGroup__IzhXE","fileLinkContainer":"fileLinkContainer__un9u3"};